import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../components/Layout/Page';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import AvailabilityEditForm from './AvailabilityEditForm';
import Header from './Header';
import AvailabilityRequest from '../../../requests/api/availability';
import useStyles from './styles';

function AvailabilityEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [availability, setAvailability] = useState();

  useEffect(() => {
    const getAvailability = async () => {
      const res = await AvailabilityRequest.getAvailabilityById(props.match.params.id);
      const response = res.data;
      if (isMountedRef.current) {
        setAvailability(response.data.availability);
      }
    };

    getAvailability();
    // eslint-disable-next-line
  }, [props]);

  if (!availability) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Editar Disponibilidad"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <AvailabilityEditForm availability={availability}/>
        </Box>
      </Container>
    </Page>
  );
}

AvailabilityEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(AvailabilityEditView);
